import React from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const boxWrapperStyles = ({ padding, customStyles, disabled }) => ({
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: ({ shape }) => shape.radius.l,
  padding: `${padding}px`,
  height: '100%',
  position: 'relative',
  ...(disabled && { backgroundColor: ({ palette }) => palette.border.default }),

  '& .menu': {
    position: 'absolute',
    top: 4,
    right: 8,
    zIndex: 100,
  },

  ...customStyles,
});

const defaultCustomStyles = {};

const RoundedBox = ({
  padding = 12,
  children = null,
  customStyles = defaultCustomStyles,
  menu = null,
  disabled = false,
  ...props
}) => (
  <Box sx={boxWrapperStyles({ padding, customStyles, disabled })} {...props}>
    <div className="menu">{menu}</div>
    {children}
  </Box>
);

RoundedBox.propTypes = {
  padding: PropTypes.number,
  customStyles: PropTypes.object,
  children: PropTypes.node,
  menu: PropTypes.node,
  disabled: PropTypes.bool,
};

export default RoundedBox;
